
export default {
  props: {
    job: {
      type:Object,
      default: () => ({}),
    },
     isLoggedIn: {
         type:Boolean,
      default: false,
    },
    hasPaid: {
      type:Boolean,
      default:false
    }
  },
}
